"use client";

import { useBookingDrawer } from "@/lib/booking-context";
import { getBookingSource } from "@/lib/booking-source";
import { useQuiz } from "@/lib/quiz-context";

export type BlokAction = "open_booking" | "open_quiz";

export function useTriggerAction() {
  const { setOpen: setBookingOpen } = useBookingDrawer();
  const { setOpen: setQuizOpen } = useQuiz();
  return (action: string | undefined | null, event?: { currentTarget: Element }) => {
    if (action === "open_booking") {
      setBookingOpen(true, getBookingSource(event?.currentTarget));
      return true;
    }
    if (action === "open_quiz") {
      setQuizOpen(true, getBookingSource(event?.currentTarget));
      return true;
    }
    return false;
  };
}
